module.exports = __webpack_public_path__ + "static/img/dj-logo.426436f.png";


//////////////////
// WEBPACK FOOTER
// ./static/dj-logo.png
// module id = D1cg
// module chunks = 1